import { useCallback, useContext } from 'react';
import AppContext from 'app/AppContext';
import { useSelectLocked } from 'layoutRenderer/store/selectors';
import {
    useDispatchLockLayout,
    useDispatchUnlockLayout,
} from 'layoutRenderer/store/dispatcher';
import { useSelectLayoutManualSave } from 'layout/store/selectors';

/*
 * Hook to save the current layout immediately if there is a pending debounced save
 */
export const usePersistDirtyLayout = () => {
    const {
        services: { currentLayoutPersistenceService },
    } = useContext(AppContext);

    return () => {
        currentLayoutPersistenceService &&
            currentLayoutPersistenceService.persistIfDirty();
    };
};

/*
 * Hook to save the current layout immediately if there is a pending debounced save
 */
export const useSaveDebouncedLayoutChange = () => {
    const {
        services: { currentLayoutPersistenceService },
    } = useContext(AppContext);

    const manualSave = useSelectLayoutManualSave();

    return useCallback(() => {
        if (manualSave) {
            return;
        }
        return (
            currentLayoutPersistenceService &&
            currentLayoutPersistenceService.persistIfDirty()
        );
    }, [currentLayoutPersistenceService, manualSave]);
};

export function useToggleLayoutLocked() {
    const isLocked = useSelectLocked();
    const saveDebouncedLayoutChange = useSaveDebouncedLayoutChange();
    const dispatchLockLayout = useDispatchLockLayout();
    const dispatchUnlockLayout = useDispatchUnlockLayout();

    const toggleLocked = () => {
        if (isLocked) {
            dispatchUnlockLayout();
        } else {
            saveDebouncedLayoutChange();
            dispatchLockLayout();
        }
    };

    return { isLocked, toggleLocked };
}
